import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer, Renderer2, SimpleChanges } from '@angular/core';
import { IPageInfo } from '../../../../base/interfaces/IPageInfo';
import { IBaseEntry } from '../../../../base/interfaces/IBaseEntry';
import { INamedEntry } from '../../../../base/interfaces/INamedEntry';
import { MatSelectChange, MatTabChangeEvent } from '@angular/material';
import { ImageBrowserElement } from './selected-element';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { CachedFileService } from '../../../../directives/file-drop/cached-file-service';
import { IFileInfo } from '../../../../directives/file-drop/interfaces/IFileInfo';
import { Observable } from 'rxjs-compat/Observable';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-image-browser',
  templateUrl: './image-browser.component.html',
  styleUrls: ['./image-browser.component.css']
})
export class ImageBrowserComponent implements OnInit, AfterViewInit, OnChanges {
 
  @Input() caption: string = null;
  @Input() container: string = null;
  @Input() partition: string = null;
  @Input() mode: string = ImageBrowserMode.DropDown;
  @Input() subTitle: string = null;
  @Input() image: string = null;
  @Input() variant: string = null;
  @Input() data: IBaseEntry[] = null;
  @Input() tabs: INamedEntry[] = null;
  @Input() loading: boolean = false;
  @Input() pageInfo: IPageInfo = null;
  @Input() previewHeight: number = 210;
  @Input() previewWidth: number = 170;
  @Input() widthProc: number = 30;  
  @Input() showPagination: boolean = true;
  @Input() showItemCaption: boolean = true;

  
  @Output() public imageSelected = new EventEmitter<ImageBrowserElement>();
  @Output() public tabSelected = new EventEmitter<IBaseEntry>();
  @Output() public scrolled = new EventEmitter();
  @Output() public refreshed = new EventEmitter();
  @Output() public nextPage = new EventEmitter<IPageInfo>();
  @Output() public prevPage = new EventEmitter<IPageInfo>();  
  @Output() public searched = new EventEmitter<string>();  

  public tabIndex = 0;  
  public form: FormGroup = null;  
  //public selectedTab: FormControl = new FormControl(null);  
  //private loadingSubject = new BehaviorSubject<boolean>(false);
  //public loading$ = this.loadingSubject.asObservable();

  constructor(
    private fileCache:CachedFileService,
    private renderer: Renderer2, 
    private elem: ElementRef) { 
      const searchCtrl = new FormControl(null);
      this.form = new FormGroup({
        selectedTab: new FormControl(null),
        searchPhrase: searchCtrl
      });
      searchCtrl.valueChanges.pipe(
        debounceTime(300),distinctUntilChanged()
      ).subscribe((searchPhrase: string) => {
        this.searched.emit(searchPhrase);
      })
    }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.tabs){
      if(changes.tabs && changes.tabs.currentValue && changes.tabs.currentValue.length > 0){
        this.onTabSelected(0);
      }      
    }
  }
  ngAfterViewInit(): void {
    let elements = this.elem.nativeElement.querySelectorAll('.mat-tab-body-content');
  }
  itemWidth = 170;
  itemHeight = 210;
  ngOnInit() {
  }
  disconnect() {
    //this.loadingSubject.complete();
  }  
  onScroll(){
    this.scrolled.emit();
  }
  onImageSelected(image:IFileStoreItem, item:INamedEntry){
    if(image && item){
      const id = item[this.image];
      const container = item[this.container];
      this.fileCache.Get(<IFileInfo>{
        container: container,
        id:id
      }).subscribe(file => {
        this.imageSelected.emit(new ImageBrowserElement(file,item));
      })  
    }    
  }
  onTabChanged(selected:MatSelectChange){
    if(selected && selected.value){
      this.onTabIdSelected(selected.value);
    }    
  }
  onTabSelected(index: number){    
    let tab = null;
    if(index>-1){
      this.tabIndex = index;
      tab = this.tabs[index];
    }
    if(tab){
      this.form.get('selectedTab').setValue(tab.id);
      this.tabSelected.emit(tab);
    }    
  }
  onTabIdSelected(id: string){    
    let tab = null;
    if(id){      
      tab = this.tabs.find(f => f.id === id);
    }
    if(tab){
      this.tabIndex = this.tabs.indexOf(tab);
      this.form.get('selectedTab').setValue(tab.id);
      this.tabSelected.emit(tab);
    }    
  }  
  onRefresh(){
    this.refreshed.emit();
  }
  onNextPage(){
    this.nextPage.emit(this.pageInfo);
  }  
  onPrevPage(){
    this.prevPage.emit(this.pageInfo);
  }    
  onTabIndexChanged(tab){
    this.onTabIdSelected(this.tabs[tab.index].id);
  }
}
function IFileInfo(IFileInfo: any) {
  throw new Error('Function not implemented.');
}

export enum ImageBrowserMode{
  DropDown = 'dropdown',
  Tabs = 'tabs'
}